import React, { Component } from 'react';
import Dropdown from 'react-dropdown'

class EnvelopeCurveDropdown extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    getOption(value) {
        return this.getOptions().filter(
            o => o.value === value)[0];
    }

    getOptions() {
        let options = OPTIONS;
        if (this.props.selectedPoint === 'DECAY') {
            options = OPTIONS.filter(
                o => o.value === 'linear' ||
                    o.value === 'exponential');
        }

        return options.map(
            x =>
                ({... x,
                  label: x.label + ' ' + this.props.selectedPoint.toLowerCase()}));
    }

    onSelectOption(option) {
        let curve = option.value;
        if (this.props.selectedPoint === 'ATTACK') {
            this.props.envelope.attackCurve = curve;
        } else if (this.props.selectedPoint === 'DECAY') {
            this.props.envelope.decayCurve = curve;
        } else if (this.props.selectedPoint === 'RELEASE') {
            this.props.envelope.releaseCurve = curve;
        }
        this.props.onUpdateEnvelopeCurve(option.value);
    }

    get envelope() {
        if (this.props.envelopeType === 'PITCH') {
            return this.props.envelope.envelope.envelope;
        }

        return this.props.envelope.envelope;
    }

    get curve() {
        let envelope = this.envelope;
        if (this.props.selectedPoint === 'ATTACK') {
            return envelope.attackCurve;
        } else if (this.props.selectedPoint === 'DECAY') {
            return envelope.decayCurve;
        } else if (this.props.selectedPoint === 'RELEASE') {
            return envelope.releaseCurve;
        }

        return '';
    }

    render() {
        return (
            <div className="envelope-curve-dropdown-container">
                <Dropdown
                  className='envelope-curve-dropdown'
                  controlClassName='envelope-curve-dropdown'
                  arrowClassName='osc-type-arrow-dropdown'
                  options={this.getOptions()}
                  onChange={(o) => this.onSelectOption(o)}
                  value={this.getOption(this.curve)}
                  placeholder="Curve" />
              </div>
        );
    }
}

const OPTIONS = [
    {value: 'linear', label: 'Linear'},
    {value: 'exponential', label: 'Exponential'},
    {value: 'sine', label: 'Sine'},
    {value: 'cosine', label: 'Cosine'},
    {value: 'bounce', label: 'Bounce'},
    {value: 'ripple', label: 'Ripple'},
    {value: 'step', label: 'Step'},
];

export default EnvelopeCurveDropdown;
